import React, { useState } from 'react'
import { Select, SelectItem } from '@ublique/components/Select'
import { isEmpty } from 'lodash'

export const SORTING_FIELD_SLC = "field"
export const SORTING_TYPE_SLC = "type" 

const SortingList = ({ isSuperuser, sortingColumns, data, labelMap, modelInfo, onChange }) => {
    const getSortingFields = () => {
        if(isEmpty(sortingColumns)){
            return [{
                sort: undefined,
                isHeaderField: true,
                parentTable: undefined,
                id: undefined,
                labelText: undefined
            }]
        }else {
            return sortingColumns
        }
    }

    const [fieldsWithSorting, setFieldsWithSorting] = useState(getSortingFields())
    const [currentField, setCurrentField] = useState()

    const createChildren = (options) => {
        const opts = [...options]
        opts.splice(0, 0, {
             id: undefined, labelText: undefined 
        })
        return opts.map(({ id, labelText }) => (<SelectItem
            key={id}
            text={labelText}
            value={id}
          />))
    }

    const orderingTypeChildren = [
        {id: 'asc', labelText: 'asc'},
        {id: 'desc', labelText: 'desc'}
    ]
  
    return (
        <div className='model-info-section-header-values'>
        {fieldsWithSorting.map((col, i) => {
          return (
            <>
              <span className='model-info-sort-parent'>
                {labelMap[col.parentTable] || modelInfo('HEADER')}
              </span>
              {modelInfo('SORT_BY')}
              {/* {isSuperuser && col.isHeaderField ?
                (
                  <Select
                    defaultValue={col.id}
                    id={`sorting-field-${i}`}
                    // onChange={({ target }) => onChange(+target.value)}
                    onChange={({target}) => onChange(col.id, SORTING_FIELD_SLC, target.value)}
                    children={createChildren(data)}
                    noLabel
                    inline
                    light
                    size='sm'
                  />
                ) : */}
                (<span className='model-info-sort-field'>
                  {col.labelText}
                </span>)
              {/* } */}

            {/* {isSuperuser && col.isHeaderField ?
                (
                  <Select
                    defaultValue={col.sort}
                    id={`sorting-type-${i}`}
                    onChange={({target}) => onChange(col.id, SORTING_TYPE_SLC, target.value)}
                    children={createChildren(orderingTypeChildren)}
                    noLabel
                    inline
                    light
                    size='sm'
                  />
                ) : */}
                (` (${col.sort})`)
              {/* } */}
              
              <div className="break"></div>
            </>
          )
        })}
      </div>
    )

}

export default SortingList
